/*
 * Renonciation au droit de rétractation — contenu numérique (art. L221-28 C. conso.)
 * ---------------------------------------------------------------------------------
 * Rôle :
 *  - Bloque TOUS les chemins de passage en caisse (bouton panier, bouton drawer,
 *    boutons dynamiques / Shop Pay / accelerated checkout) tant que la case
 *    obligatoire n'est pas cochée.
 *  - Enregistre le consentement comme ATTRIBUT de panier => preuve sur la commande
 *    (visible dans l'admin, rubrique « Informations supplémentaires »).
 *  - Décocher la case re-bloque la caisse ET vide l'attribut.
 *  - Le déblocage n'a lieu QU'APRÈS confirmation de l'écriture de l'attribut
 *    (fail-closed) : on garantit ainsi que la preuve existe avant tout checkout.
 *  - Résiste aux re-render AJAX / morph du panier (délégation + MutationObserver),
 *    desktop comme mobile.
 *
 * Cette logique est volontairement autonome (aucune dépendance au thème) et
 * idempotente : plusieurs balises <script> qui la chargent n'exécutent l'init
 * qu'une seule fois.
 */
(function () {
  if (window.__cdsConsentRetractation) return;
  window.__cdsConsentRetractation = true;

  // Clé de l'attribut de panier = libellé affiché tel quel dans l'admin commande.
  var ATTR_KEY = 'Renonciation au droit de rétractation';

  var CHECKBOX_SELECTOR = 'input[type="checkbox"][data-consent-retractation]';
  // Tous les déclencheurs de passage en caisse côté panier / drawer.
  var CHECKOUT_SELECTOR =
    'button[name="checkout"], .additional-checkout-buttons, .cart__dynamic-checkout-buttons';

  /* ---------- utilitaires ---------- */

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '') + '/cart/update.js';
  }

  function allCheckboxes() {
    return document.querySelectorAll(CHECKBOX_SELECTOR);
  }

  // Remonte depuis `el` jusqu'au 1er ancêtre contenant un élément `selector`.
  // Renvoie null si aucun (ex : bouton « Acheter maintenant » d'une fiche
  // produit, hors contexte panier => jamais bloqué par erreur).
  function climbUntil(el, selector) {
    var node = el ? el.parentElement : null;
    while (node && node !== document.body) {
      if (node.querySelector && node.querySelector(selector)) return node;
      node = node.parentElement;
    }
    if (document.body && document.body.querySelector(selector)) return document.body;
    return null;
  }

  function consentValue() {
    var iso;
    try {
      iso = new Date().toISOString();
    } catch (e) {
      iso = '';
    }
    return (
      'Acceptée le ' +
      iso +
      ' — exécution immédiate du contenu/service numérique, renonciation au droit ' +
      'de rétractation (art. L221-28 C. conso.)'
    );
  }

  /* ---------- persistance de la preuve (attribut de panier) ---------- */

  // Écrit (ou vide) l'attribut. Résout en true si le serveur a confirmé l'écriture.
  function persist(consented) {
    var attrs = {};
    attrs[ATTR_KEY] = consented ? consentValue() : '';
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function (res) {
        return !!res && res.ok;
      })
      .catch(function () {
        return false;
      });
  }

  /* ---------- feedback ---------- */

  function setMessage(wrap, type, text) {
    if (!wrap) return;
    var err = wrap.querySelector('[data-consent-error]');
    if (err) {
      if (text != null) err.textContent = text;
      err.hidden = type == null;
    }
    wrap.classList.toggle('consent-retractation--error', type === 'error');
    wrap.classList.toggle('consent-retractation--pending', type === 'pending');
  }

  /* ---------- blocage / déblocage ---------- */

  // « Débloqué » = case cochée ET attribut confirmé enregistré.
  function isCleared(cb) {
    if (cb._consentSaved === undefined) cb._consentSaved = cb.checked;
    return cb.checked && cb._consentSaved === true;
  }

  function applyGate() {
    allCheckboxes().forEach(function (cb) {
      var ok = isCleared(cb);
      var scope = climbUntil(cb, CHECKOUT_SELECTOR) || document;

      scope.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        btn.disabled = !ok;
        btn.setAttribute('aria-disabled', String(!ok));
      });
      scope
        .querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons')
        .forEach(function (box) {
          box.classList.toggle('consent-blocked', !ok);
          box.setAttribute('aria-disabled', String(!ok));
        });

      if (ok) setMessage(cb.closest('[data-consent-retractation-wrap]'), null, null);
    });
  }

  /* ---------- changement de la case ---------- */

  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest(CHECKBOX_SELECTOR) : null;
    if (!cb) return;

    var wrap = cb.closest('[data-consent-retractation-wrap]');
    var seq = (cb._consentSeq = (cb._consentSeq || 0) + 1);
    var checked = cb.checked;

    cb._consentSaved = false; // on re-bloque immédiatement le temps de l'écriture
    applyGate();
    if (checked) {
      setMessage(wrap, 'pending', 'Enregistrement de votre consentement…');
    } else {
      setMessage(wrap, null, null);
    }

    persist(checked).then(function (ok) {
      if (seq !== cb._consentSeq) return; // une action plus récente a eu lieu
      cb._consentSaved = checked && ok;
      if (checked && !ok) {
        setMessage(
          wrap,
          'error',
          "L'enregistrement a échoué. Vérifiez votre connexion et recochez la case."
        );
      } else {
        setMessage(wrap, null, null);
      }
      applyGate();
    });
  });

  /* ---------- garde-fou : clic sur un bouton de caisse (phase capture) ---------- */

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest(CHECKOUT_SELECTOR) : null;
      if (!trigger) return;
      var scope = climbUntil(trigger, CHECKBOX_SELECTOR);
      if (!scope) return; // hors contexte panier => on laisse passer
      var cb = scope.querySelector(CHECKBOX_SELECTOR);
      if (!cb || isCleared(cb)) return; // consenti + enregistré => on laisse passer

      e.preventDefault();
      e.stopImmediatePropagation();
      var wrap = cb.closest('[data-consent-retractation-wrap]');
      if (cb.checked) {
        setMessage(wrap, 'pending', 'Enregistrement de votre consentement… merci de patienter.');
      } else {
        setMessage(wrap, 'error', 'Vous devez cocher cette case pour finaliser votre commande.');
      }
      try {
        cb.focus();
      } catch (err) {}
      if (cb.scrollIntoView) cb.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  /* ---------- garde-fou : soumission du formulaire panier (phase capture) ---------- */

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var isCartForm =
        form.id === 'cart' ||
        form.id === 'cart-form' ||
        form.id === 'CartDrawer-Form' ||
        !!form.querySelector('button[name="checkout"]');
      if (!isCartForm) return;

      var scope = (e.submitter && climbUntil(e.submitter, CHECKBOX_SELECTOR)) || climbUntil(form, CHECKBOX_SELECTOR);
      var cb = scope && scope.querySelector(CHECKBOX_SELECTOR);
      if (!cb) {
        // repli : bouton hors du <form> (attribut form=) -> on prend la 1re case non validée
        var boxes = allCheckboxes();
        for (var i = 0; i < boxes.length; i++) {
          if (!isCleared(boxes[i])) {
            cb = boxes[i];
            break;
          }
        }
      }
      if (cb && !isCleared(cb)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var wrap = cb.closest('[data-consent-retractation-wrap]');
        setMessage(
          wrap,
          cb.checked ? 'pending' : 'error',
          cb.checked
            ? 'Enregistrement de votre consentement… merci de patienter.'
            : 'Vous devez cocher cette case pour finaliser votre commande.'
        );
        if (cb.scrollIntoView) cb.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    true
  );

  /* ---------- ré-application après re-render AJAX / morph ---------- */

  var rafId = 0;
  function scheduleGate() {
    if (rafId) return;
    var run = function () {
      rafId = 0;
      applyGate();
    };
    rafId = window.requestAnimationFrame ? window.requestAnimationFrame(run) : setTimeout(run, 16);
  }

  document.addEventListener('cart:update', scheduleGate); // Horizon / CDS
  document.addEventListener('cart:refresh', scheduleGate);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scheduleGate();
        return;
      }
    }
  });

  function init() {
    applyGate();
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', applyGate);
})();
